import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { listLocales } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { customRequiredValidator } from '../../../core/function/customFormValidatorFunction';
import { ApproveRejectResponse, ModalResponse } from '../../../models/shared-component/modal-response-model';
import { User } from '../../../models/shared-component/user';
import { AuthService } from '../../../services/auth.service';
import { ShareService } from '../../../services/shared.service';

@Component({
  selector: 'app-approve-reject-modal',
  templateUrl: './approve-reject-modal.component.html',
  styleUrls: ['./approve-reject-modal.component.scss']
})
export class ApproveRejectModalComponent implements OnInit {
  @Input() title: string;
  @Input() isApprove: boolean = false;

  @Output() action = new EventEmitter<ApproveRejectResponse>();

  locale = 'th-be';
  locales = listLocales();
  public form: FormGroup;
  currentUser: User;

  constructor(public bsModalRef: NgbActiveModal,
    public sharedService: ShareService,
    private formBuilder: FormBuilder,
    private localeService: BsLocaleService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.localeService.use(this.locale);
    this.currentUser = this.authService.currentUserValue;
    this.initialForm();
  }

  confirm(): void {
    if (this.form.invalid) {
      Object.keys(this.form['controls']).forEach(key => { this.form['controls'][key].markAsTouched(); });
      return;
    }
    var response = this.form.getRawValue() as ApproveRejectResponse;
    this.action.emit(response);
    this.bsModalRef.close();
  }

  cancel(): void {
    this.bsModalRef.close();
  }

  initialForm(): void {
    this.form = this.formBuilder.group({
      approveDate: [null, Validators.required],
      approveReason: [null],
      approveBy: [this.currentUser.id],
      approveByName: [this.currentUser.firstName],
    }, {
      validators: [
        customRequiredValidator('approveReason', form => !this.isApprove),
      ]
    }
    );

    this.form.get('approveByName')?.disable();
  }

  isFormInvalid(formControlName: string): boolean {
    return (this.form.controls[formControlName].touched || this.form.controls[formControlName].dirty) && this.form.controls[formControlName].invalid
  }
}
